/*
  Personalization field behaviors — ported from the previous theme.
  Field markup comes from snippets/pers-field.liquid (rendered by
  snippets/product-personalization.liquid). This binds character counters,
  numeric clamping, and the logo/image upload flow, driven by data-* attrs.

  The add-to-cart form (cart.js) already posts all `properties[...]` inputs via
  FormData, so no cart wiring is needed here — a file upload just writes the
  returned URL into its hidden property input before submit.
*/
(function () {
  function initPersonalization(root) {
    (root || document).querySelectorAll('[data-personalize] .pd-personalize__field').forEach(function (field) {
      var input = field.querySelector('input, textarea');
      if (!input || input.dataset.persBound === '1') return;
      input.dataset.persBound = '1';

      // Logo/file upload: preview + validate, then upload to the configured endpoint
      // (a Cloudflare Worker → R2) and store the RETURNED URL in the hidden property
      // field. Only a short text URL submits, so normal AJAX add-to-cart works and the
      // order shows a real, clickable link (not the useless "C:\fakepath" string).
      if (input.hasAttribute('data-pers-file')) {
        var wrap = field.querySelector('[data-pers-upload]');
        var thumb = field.querySelector('[data-pers-thumb]');
        var textEl = field.querySelector('[data-pers-upload-text]');
        var clearBtn = field.querySelector('[data-pers-clear]');
        var errEl = field.querySelector('[data-pers-error]');
        var urlInput = field.querySelector('[data-pers-file-url]');
        var endpoint = ((wrap && wrap.getAttribute('data-endpoint')) || '').trim();
        var maxMb = parseFloat(input.getAttribute('data-max-mb')) || 10;
        var okTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'image/svg+xml', 'application/pdf'];
        var defaultHtml = textEl ? textEl.innerHTML : '';
        var form = input.closest('form');
        var submitBtn = form ? form.querySelector('[type="submit"]') : null;

        var showErr = function (msg) { if (errEl) { errEl.textContent = msg || ''; errEl.hidden = !msg; } };
        var short = function (n) { return (n && n.length > 26 ? n.slice(0, 23) + '…' : (n || '')); };
        var setText = function (bold, small) {
          if (!textEl) return;
          textEl.textContent = '';
          var b = document.createElement('b'); b.textContent = bold; textEl.appendChild(b);
          if (small) { var s = document.createElement('small'); s.textContent = small; textEl.appendChild(s); }
        };
        var reset = function () {
          input.value = '';
          if (urlInput) urlInput.value = '';
          if (thumb) { thumb.hidden = true; thumb.removeAttribute('src'); }
          if (textEl) textEl.innerHTML = defaultHtml;
          if (clearBtn) clearBtn.hidden = true;
          if (wrap) wrap.classList.remove('has-file', 'is-uploading');
          if (submitBtn) submitBtn.disabled = false;
          showErr('');
        };

        input.addEventListener('change', function () {
          var file = input.files && input.files[0];
          if (!file) { reset(); return; }
          if (file.size > maxMb * 1024 * 1024) { showErr('File is too large (max ' + maxMb + 'MB).'); reset(); return; }
          if (okTypes.indexOf(file.type) === -1) { showErr('Please use PNG, JPG, SVG or PDF.'); reset(); return; }
          showErr('');
          if (urlInput) urlInput.value = '';
          if (wrap) wrap.classList.add('has-file');
          if (clearBtn) clearBtn.hidden = false;

          // Instant local thumbnail (before the upload finishes)
          if (thumb && file.type.indexOf('image/') === 0 && file.type !== 'image/svg+xml') {
            var reader = new FileReader();
            reader.onload = function (ev) { thumb.src = ev.target.result; thumb.hidden = false; };
            reader.readAsDataURL(file);
          } else if (thumb) { thumb.hidden = true; }

          if (!endpoint) { setText(short(file.name), 'Selected'); return; }

          // Upload → store the returned URL. Block checkout until it's done.
          setText('Uploading…', short(file.name));
          if (wrap) wrap.classList.add('is-uploading');
          if (submitBtn) submitBtn.disabled = true;
          var fd = new FormData(); fd.append('file', file);
          fetch(endpoint, { method: 'POST', body: fd })
            .then(function (r) { return (r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status))); })
            .then(function (data) {
              if (!data || !data.url) throw new Error('No URL returned');
              if (urlInput) urlInput.value = data.url;
              setText(short(file.name), 'Uploaded ✓ — tap to change');
            })
            .catch(function () { showErr('Upload failed — please try again.'); reset(); })
            .finally(function () {
              if (wrap) wrap.classList.remove('is-uploading');
              if (submitBtn) submitBtn.disabled = false;
            });
        });
        if (clearBtn) clearBtn.addEventListener('click', reset);
        return;
      }

      var counter = field.querySelector('[data-pers-counter]');

      // Numeric field: strip non-digits, clamp to max value, count digits.
      if (input.hasAttribute('data-pers-number')) {
        var max = parseInt(input.getAttribute('data-max'), 10) || 99;
        var digits = parseInt(input.getAttribute('data-digits'), 10) || String(max).length;
        var updateNum = function () {
          if (!counter) return;
          var len = input.value.length;
          counter.textContent = len + '/' + digits;
          counter.style.color = len >= digits ? 'var(--color-error, #BF0A30)' : '';
        };
        input.addEventListener('input', function () {
          var v = input.value.replace(/\D+/g, '');
          if (v && parseInt(v, 10) > max) v = String(max);
          if (v !== input.value) input.value = v;
          updateNum();
        });
        updateNum();
        return;
      }

      // Text / textarea: character counter, only when a max length is set.
      var maxLen = parseInt(input.getAttribute('data-max'), 10);
      if (counter && maxLen) {
        var updateLen = function () {
          var len = input.value.length;
          counter.textContent = len + '/' + maxLen;
          counter.style.color = len >= maxLen ? 'var(--color-error, #BF0A30)' : '';
        };
        input.addEventListener('input', updateLen);
        updateLen();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initPersonalization(document); });
  } else {
    initPersonalization(document);
  }
  // Re-init when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { initPersonalization(e.target); });
})();
